import { isOnlineOnlyRestricted } from "@faire/retailer-visitor-shared/lib/brandRestrictionUtils";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
export var canAddToCart = function(brand) {
    return !!RetailerStore.get().retailer && !getIsBrandPreview() && !isOnlineOnlyRestricted(brand);
};
